<div class="grid-x">
  <div class="cell">
    <form [formGroup]="editDomainTypeForm" (ngSubmit)="onSubmit()">
      <div class="grid-x" *ngIf="isCreatingDomain">
        <div class="cell large-4 medium-6 small-6"><label>Domain Type:</label></div>
        <div class="cell large-8 medium-6 small-6"><input type="radio" name="domainType" formControlName="domainType"
                                                          value="{{getDomainTypeValue(0)}}" checked>&nbsp;{{getDomainTypeDisplayValue(0) | titlecase}} TLD
          <input type="radio" name="domainType" formControlName="domainType" value="{{getDomainTypeValue(1)}}">&nbsp;{{getDomainTypeDisplayValue(1) | titlecase}} TLD
        </div>
      </div>

      <div class="grid-x" *ngIf="!isCreatingDomain">
        <div class="cell" style="margin-left: 25%">
          You are trying to delegate {{getDomainType() | titlecase}} TLD for {{domainName| domainNameConverter}}. Please click "Next" to continue.
        </div>
      </div>

      <div class="grid-x">
          <div class="save-cancel-button-group">
            <button class="iana-button-cancel" (click)="cancel()">Cancel</button>
            <button class="iana-button" [disabled]="isFormInValid()" type="submit">Next
            </button>
          </div>
      </div>
    </form>
  </div>

</div>
